export default __webpack_public_path__ + "static/media/produtor.2dddbc4a.png";